import styled from "styled-components";
import { layout, flexbox } from "styled-system";
import { remCalc, media } from "../../../theme/style-utils-coras-nua";
import defaultTheme from "../../../theme/theme-test-override";

export const StyledRowContainerItem = styled.div`
    & > div:first-of-type {
        color: ${props => props.theme.colors.monotoneDark};
        font-size: ${props => props.theme.fontSizes[1]};
        padding: 0 0 ${remCalc(8)} 0;
    }

    & > div:last-of-type {
        padding-bottom: 0;

        & > .react-select-container,
        & > .react-aria-Select,
        & > .react-aria-ComboBox {
            margin-top: 0;
        }
        & > .field-error {
            display: none;
        }
    }
`;

const StyledRowContainer = styled.div`
    ${layout}
    ${flexbox}
    & > div {
        margin-right: ${remCalc(24)};
        width: calc(1 / 2 * 100% - (1 - 1 / 2) * ${remCalc(24)});
        /* Mobile considerations */
        ${media.sm.down`
            margin-right: ${remCalc(12)};
            width: calc(1/2*100% - (1 - 1/2)*${remCalc(12)});
        `}

        &:nth-child(2n) {
            margin-right: 0;
        }

        & > div,
        & > input {
            ${media.sm.up`
                max-width: ${remCalc(251)};
            `}
            ${media.sm.down`
                & .react-select__value-container {
                    overflow: visible;
                }
                & .react-select__indicators {
                    display: none;
                }
            `}
        }
    }
`;

export const StyledRowError = styled.div`
    ${flexbox}
    color: ${props => props.theme.colors.alert};
    font-size: ${remCalc(16)};
    margin-top: ${remCalc(4)};
`;

StyledRowContainerItem.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

StyledRowContainer.defaultProps = {
    theme: {
        ...defaultTheme
    },
    ml: 0,
    mr: "auto",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    order: "3"
};

StyledRowError.defaultProps = {
    theme: {
        ...defaultTheme
    },
    order: "6"
};

export default StyledRowContainer;
